module.exports = __webpack_public_path__ + "img/hk01-20201123.cc0124de.jpg";